import { render, staticRenderFns } from "./RiskDistribution.vue?vue&type=template&id=05307134&scoped=true"
import script from "./RiskDistribution.vue?vue&type=script&lang=js"
export * from "./RiskDistribution.vue?vue&type=script&lang=js"
import style0 from "./RiskDistribution.vue?vue&type=style&index=0&id=05307134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05307134",
  null
  
)

export default component.exports